<template>
    <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <Aside></Aside>
        <!--end::Aside-->
        <div class="d-flex flex-column flex-row-fluid wrapper pt-0" id="kt_wrapper">
            <div class="d-flex flex-column" style="min-height: 100vh;">
                <Toasts :firebase-uid="auth_uid"/>
                <StoreHeader v-if="$page.props.store" :store="$page.props.store"/>
                <FlashMessages class="mx-5"/>

                <div class="mx-5 mt-5 pt-3 flex-grow-1">
                    <slot/>
                </div>

                <PageFooter/>
            </div>
        </div>
    </div>
</template>

<script>
import Toasts from '@components/Toasts'
import StoreHeader from '@components/Store/StoreHeader.vue'
import FlashMessages from '@components/FlashMessages.vue'
import Aside from '@components/Navigation/Aside.vue'
import PageFooter from '@layouts/Includes/PageFooter.vue'

export default {

    components: {
        PageFooter,
        Toasts,
        StoreHeader,
        FlashMessages,
        Aside
    },

    props: {
        auth_uid: String,
    },
}
</script>
